
import { Options, Vue } from "vue-class-component";
import { ref } from "vue";
import * as echarts from "echarts";

import {
  dispatchGetReportStat,
  dispatchGetVisitStatistics,
  dispatchGetVisitStatTrend,
  dispatchGetTopPerformance,
  dispatchGetTopProjectPerformance,
  dispatchGetTopMainLabelPerformance,
  dispatchGetTopModelPerformance,
  dispatchGetTopLevelPerformance,
  dispatchGetTopTesterPerformance,
  dispatchGetProjects,
  dispatchGetTopPerformanceList,
  dispatchGetMyProjects,
} from "@/store/project/actions";
import { dispatchCreateSceneScriptTop } from "@/store/task/actions";
import { store } from "@/store";
import Quill from "quill";
import { ElMessage } from "element-plus";
import {
  compare,
  dateConversion,
  getLocalProject,
  special_projects,
  unique_json,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import {
  readAdminProjects,
  readMyProjects,
  readProjectDetail,
  readTopProjectScenes,
  readtopModelList,
  readtopVersionList,
  readtopModelListVersion,
  readtopVersionListVersion,
} from "@/store/project/getters";
import {
  dispatchGetTopCpuList,
  dispatchGetTopProjectList,
  dispatchGetTopSceneList,
  dispatchGetTopModelList,
  dispatchGetTopModelListVersion,
  dispatchGetTopProjectScenes,
  dispatchGetTopVersionList,
  dispatchGetTopVersionListVersion,
  dispatchGetTopSceneListVersion,
  dispatchGetTopProblemByCpu,
  dispatchGetTopProjectType,
  dispatchGetTopVersionData,
  dispatchGetTopVersionListProblem,
  dispatchGetTopProblemSummary,
} from "@/store/project/actions";
import {
  readtopCpuList,
  readtopSceneList,
  readtopSceneListVersion,
  readtopProblemByCpu,
  readtopProjectType,
  readtopVersionData,
  readtopProblemSummary,
  readtopVersionListProblem,
} from "@/store/project/getters";
import {
  readTopBaselines,
  readTopTemplates,
  readTopTemplatesData,
  readTopBaselinesData,
} from "@/store/performance/getters";
import {
  dispatchDeepTopDownLoad,
  dispatchUploadTopPerformance,
  dispatchDeletetopPerformance,
  dispatchUploadPerformanceUpload,
  dispatchAddBug,
  dispatchGetProblemSummay,
  dispatchGetTopTemplates,
  dispatchTopTemplatesCreate,
  dispatchTopTemplatesEdit,
  dispatchGetTopTemplatesData,
  dispatchTopBaselinesCreate,
  dispatchGetTopBaselines,
  dispatchGetTopBaselinesData,
  dispatchTopBaselinesEdit,
  dispatchUploadPerformanceTable,
  dispatcTopDataEdit,
} from "@/store/performance/actions";

import { readUploadTopPerformanceLoad } from "@/store/performance/getters";
// @Options({
//   components: {},
// })
export default class TopSearch extends Vue {
  public localProject = Number(getLocalProject());
  public data_type = [
    { name: "首轮数据", value: "1" },
    { name: "回归数据", value: "2" },
  ];
  public async project_btn() {
    this.project_page = 1;
    this.project_size = 10;
    this.project_loading = true;
    await this.project_data_api();
  }
  public problem_loading = false;
  public project_loading = false;
  public version_loading = false;
  public async project_data_api() {
    await dispatchGetTopProjectType(store, {
      project: this.localProject,
      project_list: this.project_game,
      type: this.project_type,
      scene_list: this.project_scene,
      model_list: this.project_model,
      version: this.project_version,
    });
    this.project_loading = false;
  }
  public indexMethod2(index: any) {
    return index + 1 + (this.problem_page - 1) * this.problem_size;
  }
  public get version_data() {
    return readtopVersionData(store);
  }
  public async version_data_api() {
    await dispatchGetTopVersionData(store, {
      project: this.localProject,
      top_project: this.version_game,
      type: this.version_type,
      scene: this.version_scene,
      model_list: this.version_model,
      version_list: this.version_version,
    });
    this.version_loading = false;
  }
  public get project_data() {
    return readtopProjectType(store);
  }
  public page = 1;
  public size = 10;
  public page_version = 1;
  public problem_page = 1;
  public problem_size = 10;
  public size_version = 10;
  public TOPParams = {
    avg_fps: "AvgFPS",
    fps_gt_18_pcnt: "FPS>=18[%]",
    fps_gt_25_pcnt: "FPS>=25[%]",
    avg_pss: "AvgPSS",
    max_pss: "MaxPSS",
    avg_cpu: "AvgCPU",
    cpu_lt_90_pcnt: "CPU<90[%]",
    jank: "Jank(/10min)",
    big_jank: "BigJank(/10min)",
    avg_power: "平均功耗Avg(Power)[mW]",
    min10_flow: "10min流量(KB)",
    start_temp: "开始温度",
    end_temp: "结束最高温度",
    caton: "主观卡顿",
    fever: "主观发热",
    is_crash: "是否闪退",
  };
  public cpu_type = "";
  public cpu_name = "";
  public project_type = "";
  public project_scene = [];
  public project_game = [];
  public project_model = [];
  public project_version = [];
  public project_param = [];
  public version_type = "";
  public version_game = "";
  public problem_game = "";
  public problem_type = "";
  public version_scene = "";
  public problem_version = "";
  public version_version = [];
  public version_model = [];
  public version_param = [];
  public project_size = 10;
  public project_page = 1;
  public get cpuList() {
    return readtopCpuList(store).cpu_list;
  }
  public;
  public async searchChange(type, item) {
    if (type === "project") {
      console.log(item.includes("scene"));
      if (item.includes("scene")) {
        console.log(222);
        this.project_scene = [];
        await dispatchGetTopSceneList(store, {
          project: this.localProject,
          project_list: this.project_game,
          type: Number(this.project_type),
        });
      }
      if (item.includes("model")) {
        this.project_model = [];
        await dispatchGetTopModelList(store, {
          project: this.localProject,
          project_list: this.project_game,
          type: Number(this.project_type),
          scene_list: this.project_scene,
        });
      }
      if (item.includes("version")) {
        this.project_version = [];
        await dispatchGetTopVersionList(store, {
          project: this.localProject,
          project_list: this.project_game,
          type: Number(this.project_type),
          scene_list: this.project_scene,
          model_list: this.project_model,
        });
      }
      //  this.project_data_api()
    }
    if (type === "version") {
      if (item.includes("scene")) {
        console.log(222);
        this.version_scene = "";
        await dispatchGetTopSceneListVersion(store, {
          project: this.localProject,
          top_project: this.version_game,
          type: Number(this.version_type),
        });
      }
      if (item.includes("model")) {
        this.version_model = [];
        await dispatchGetTopModelListVersion(store, {
          project: this.localProject,
          top_project: this.version_game,
          type: Number(this.version_type),
          scene: this.version_scene,
        });
      }
      if (item.includes("version")) {
        this.version_version = [];
        await dispatchGetTopVersionListVersion(store, {
          project: this.localProject,
          top_project: this.version_game,
          type: Number(this.version_type),
          scene: this.version_scene,
          model_list: this.version_model,
        });
      }
      // this.version_data_api()
    }
  }
  public async version_btn() {
    this.page_version = 10;
    this.size_version = 1;
    this.version_loading = true;
    await this.version_data_api();
  }
  public async cpu_btn() {
    this.cpu_loading = true;
    this.size = 10;
    this.page = 1;
    await this.cpu_serch_data();
  }
  public cpu_loading = false;
  public get sceneList() {
    return readtopSceneList(store).scene_list;
  }
  public get sceneList_version() {
    return readtopSceneListVersion(store).scene_list;
  }
  public get versionList() {
    return readtopVersionList(store).version_list;
  }
  public get versionList_version() {
    return readtopVersionListVersion(store).version_list;
  }
  public get prolblemVersionList_version() {
    return readtopVersionListProblem(store).version_list;
  }
  public get topProjectScenes() {
    return readTopProjectScenes(store);
  }
  public get topProjectModel() {
    return readtopModelList(store).model_list;
  }
  public get topProjectModel_version() {
    return readtopModelListVersion(store).model_list;
  }
  public async mounted() {
    dispatchGetTopCpuList(store, {
      project: this.localProject,
      search: "",
    });
    await dispatchGetTopProjectScenes(store, {
      project: this.localProject,
    });
    this.project_api();
    // this.cpu_serch_data()
    this.version_api();
    this.problem_api();
  }
  public async cpu_serch_data() {
    await dispatchGetTopProblemByCpu(store, {
      project: this.localProject,
      type: this.cpu_type ? Number(this.cpu_type) : "",
      cpu_name: this.cpu_name,
    });
    this.cpu_loading = false;
  }

  public get cpu_serch_data_store() {
    console.log(readtopProblemByCpu(store));
    return readtopProblemByCpu(store);
  }
  public async project_api() {
    await dispatchGetTopSceneList(store, {
      project: this.localProject,
      project_list: this.project_game,
      type: Number(this.project_type),
    });
    await dispatchGetTopModelList(store, {
      project: this.localProject,
      project_list: this.project_game,
      type: Number(this.project_type),
      scene_list: this.project_scene,
    });
    await dispatchGetTopVersionList(store, {
      project: this.localProject,
      project_list: this.project_game,
      type: Number(this.project_type),
      scene_list: this.project_scene,
      model_list: this.project_model,
    });
    // this.project_data_api()
  }
  public problem_api() {
    dispatchGetTopVersionListProblem(store, {
      project: this.localProject,
      top_project: this.problem_game,
      type: Number(this.problem_type),
      scene: "",
      model_name: "",
    });
  }

  public async problemChange() {
    this.problem_version = "";

    await dispatchGetTopVersionListProblem(store, {
      project: this.localProject,
      top_project: this.problem_game,
      type: Number(this.problem_type),
      scene: "",
      model_name: "",
    });
  }
  public async problem_btn() {
    this.problem_page = 1;
    this.problem_size = 10;
    this.problem_loading = true;
    await dispatchGetTopProblemSummary(store, {
      project: this.localProject,
      top_project: this.problem_game,
      type: Number(this.problem_type),
      version: this.problem_version,
    });
    this.problem_loading = false;
  }
  public get problemData() {
    return readtopProblemSummary(store);
  }
  public async version_api() {
    await dispatchGetTopSceneListVersion(store, {
      project: this.localProject,
      top_project: this.version_game,
      type: Number(this.version_type),
    });
    await dispatchGetTopModelListVersion(store, {
      project: this.localProject,
      top_project: this.version_game,
      type: Number(this.version_type),
      scene: this.version_scene,
    });
    await dispatchGetTopVersionListVersion(store, {
      project: this.localProject,
      top_project: this.version_game,
      type: Number(this.version_type),
      scene: this.version_scene,
      model_list: this.version_model,
    });
  }
  public async filterCpuList(query) {
    await dispatchGetTopCpuList(store, {
      project: this.localProject,
      search: query,
    });
  }
}
